// extracted by mini-css-extract-plugin
export var colorSquare = "_t2-0";
export var danger = "_t2-5";
export var lightPink = "_t2-8";
export var neutralBlue = "_t2-7";
export var neutralYellow = "_t2-6";
export var normal = "_t2-1";
export var primary = "_t2-2";
export var primaryLight = "_t2-3";
export var solidBlack = "_t2-g";
export var solidGreen = "_t2-b";
export var solidLightBlue = "_t2-d";
export var solidNavy = "_t2-c";
export var solidOrange = "_t2-f";
export var solidPink = "_t2-e";
export var solidRed = "_t2-9";
export var solidYellow = "_t2-a";
export var success = "_t2-4";